import { render, staticRenderFns } from "./SupportTicketsHome.vue?vue&type=template&id=660e2720"
import script from "./SupportTicketsHome.vue?vue&type=script&lang=js"
export * from "./SupportTicketsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports